/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateAppointmentRequestDto
 */
export interface UpdateAppointmentRequestDto {
    /**
     * Appointment title
     * @type {string}
     * @memberof UpdateAppointmentRequestDto
     */
    title: string;
    /**
     * Appointment description
     * @type {string}
     * @memberof UpdateAppointmentRequestDto
     */
    description: string;
    /**
     * Start time in ISO 8601 format (UTC)
     * @type {Date}
     * @memberof UpdateAppointmentRequestDto
     */
    startTime?: Date;
    /**
     * End time in ISO 8601 format (UTC)
     * @type {Date}
     * @memberof UpdateAppointmentRequestDto
     */
    endTime?: Date;
    /**
     * Notes
     * @type {string}
     * @memberof UpdateAppointmentRequestDto
     */
    notes?: string;
    /**
     * Local time zone
     * @type {string}
     * @memberof UpdateAppointmentRequestDto
     */
    localTimeZone: string;
    /**
     * Appointment type ID
     * @type {string}
     * @memberof UpdateAppointmentRequestDto
     */
    appointmentTypeId?: string;
    /**
     * Reassign the appointment to a different provider (attendee, not the meeting host)
     * @type {string}
     * @memberof UpdateAppointmentRequestDto
     */
    providerId?: string;
}

/**
 * Check if a given object implements the UpdateAppointmentRequestDto interface.
 */
export function instanceOfUpdateAppointmentRequestDto(value: object): value is UpdateAppointmentRequestDto {
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('localTimeZone' in value) || value['localTimeZone'] === undefined) return false;
    return true;
}

export function UpdateAppointmentRequestDtoFromJSON(json: any): UpdateAppointmentRequestDto {
    return UpdateAppointmentRequestDtoFromJSONTyped(json, false);
}

export function UpdateAppointmentRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateAppointmentRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'],
        'description': json['description'],
        'startTime': json['startTime'] == null ? undefined : (new Date(json['startTime'])),
        'endTime': json['endTime'] == null ? undefined : (new Date(json['endTime'])),
        'notes': json['notes'] == null ? undefined : json['notes'],
        'localTimeZone': json['localTimeZone'],
        'appointmentTypeId': json['appointmentTypeId'] == null ? undefined : json['appointmentTypeId'],
        'providerId': json['providerId'] == null ? undefined : json['providerId'],
    };
}

export function UpdateAppointmentRequestDtoToJSON(json: any): UpdateAppointmentRequestDto {
    return UpdateAppointmentRequestDtoToJSONTyped(json, false);
}

export function UpdateAppointmentRequestDtoToJSONTyped(value?: UpdateAppointmentRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'description': value['description'],
        'startTime': value['startTime'] == null ? undefined : ((value['startTime']).toISOString()),
        'endTime': value['endTime'] == null ? undefined : ((value['endTime']).toISOString()),
        'notes': value['notes'],
        'localTimeZone': value['localTimeZone'],
        'appointmentTypeId': value['appointmentTypeId'],
        'providerId': value['providerId'],
    };
}

